package com.essntl.features.file.ui

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.file.ui.DeleteFileState

data class FileState(
    val getAllFile: State<List<FileModel>> = State(),
    val deleteFileState: DeleteFileState = DeleteFileState(),
)